// extracted by mini-css-extract-plugin
export default {"progressBarWrapper":"ProgressBar_progressBarWrapper__+ED1S","progress":"ProgressBar_progress__SL7FS"};